const isMac = navigator.platform.toUpperCase().includes("MAC")

export default isMac